import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';
import config from '../../config';
import { types as sdkTypes } from '../../util/sdkLoader';
import { isTransactionsTransitionInvalidTransition, storableError } from '../../util/errors';
import {
  txIsEnquired,
  txIsRequestedContact,
  TRANSITION_APPROVE_OFFER,
  TRANSITION_SEND_CALENDAR_LINK,
  TRANSITION_REQUEST_AFTER_ENQUIRY,
  TRANSITION_ACCEPT_OFFER_COMPLETE,
  TRANSITION_CANCELL_OFFER_BY_CUSTOMER,
  TRANSITION_CANCELL_OFFER_BY_PROVIDER,
  TRANSITION_PAYMENT_REQUEST,
  TRANSITION_SEND_OFFER,
  TRANSITION_REQUEST_OFFER_COMPLETE,
  TRANSITION_DECLINE_OFFER_COMPLETE,
  setViewedForOtherUser,
  getOtherUserId
} from '../../util/transaction';
import {
  post,
  transactionLineItems,
  addCustomerEmailReminder,
  removeCustomerEmailReminder,
  setUnreadMessagesToTx
} from '../../util/api';
import * as log from '../../util/log';
import {
  updatedEntities,
  denormalisedEntities,
  denormalisedResponseEntities,
} from '../../util/data';
import { findNextBoundary, nextMonthFn, monthIdStringInTimeZone } from '../../util/dates';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUserNotifications } from '../../ducks/user.duck';
import { updateTransaction } from '../../util/api';

const { UUID } = sdkTypes;

const MESSAGES_PAGE_SIZE = 100;
const CUSTOMER = 'customer';

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/TransactionPage/SET_INITIAL_VALUES';

export const FETCH_TRANSACTION_REQUEST = 'app/TransactionPage/FETCH_TRANSACTION_REQUEST';
export const FETCH_TRANSACTION_SUCCESS = 'app/TransactionPage/FETCH_TRANSACTION_SUCCESS';
export const FETCH_TRANSACTION_ERROR = 'app/TransactionPage/FETCH_TRANSACTION_ERROR';

export const FETCH_TRANSITIONS_REQUEST = 'app/TransactionPage/FETCH_TRANSITIONS_REQUEST';
export const FETCH_TRANSITIONS_SUCCESS = 'app/TransactionPage/FETCH_TRANSITIONS_SUCCESS';
export const FETCH_TRANSITIONS_ERROR = 'app/TransactionPage/FETCH_TRANSITIONS_ERROR';

export const ACCEPT_SALE_REQUEST = 'app/TransactionPage/ACCEPT_SALE_REQUEST';
export const ACCEPT_SALE_SUCCESS = 'app/TransactionPage/ACCEPT_SALE_SUCCESS';
export const ACCEPT_SALE_ERROR = 'app/TransactionPage/ACCEPT_SALE_ERROR';

export const DECLINE_SALE_REQUEST = 'app/TransactionPage/DECLINE_SALE_REQUEST';
export const DECLINE_SALE_SUCCESS = 'app/TransactionPage/DECLINE_SALE_SUCCESS';
export const DECLINE_SALE_ERROR = 'app/TransactionPage/DECLINE_SALE_ERROR';

export const FETCH_MESSAGES_REQUEST = 'app/TransactionPage/FETCH_MESSAGES_REQUEST';
export const FETCH_MESSAGES_SUCCESS = 'app/TransactionPage/FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_ERROR = 'app/TransactionPage/FETCH_MESSAGES_ERROR';

export const SEND_MESSAGE_REQUEST = 'app/TransactionPage/SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'app/TransactionPage/SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = 'app/TransactionPage/SEND_MESSAGE_ERROR';

export const SEND_REVIEW_REQUEST = 'app/TransactionPage/SEND_REVIEW_REQUEST';
export const SEND_REVIEW_SUCCESS = 'app/TransactionPage/SEND_REVIEW_SUCCESS';
export const SEND_REVIEW_ERROR = 'app/TransactionPage/SEND_REVIEW_ERROR';

export const FETCH_TIME_SLOTS_REQUEST = 'app/TransactionPage/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'app/TransactionPage/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR = 'app/TransactionPage/FETCH_TIME_SLOTS_ERROR';

export const FETCH_LINE_ITEMS_REQUEST = 'app/TransactionPage/FETCH_LINE_ITEMS_REQUEST';
export const FETCH_LINE_ITEMS_SUCCESS = 'app/TransactionPage/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR = 'app/TransactionPage/FETCH_LINE_ITEMS_ERROR';

export const ENQUIRY_ACTION_REQUEST = 'app/TransactionPage/ENQUIRY_ACTION_REQUEST';
export const ENQUIRY_ACTION_SUCCESS = 'app/TransactionPage/ENQUIRY_ACTION_SUCCESS';
export const ENQUIRY_ACTION_ERROR = 'app/TransactionPage/ENQUIRY_ACTION_ERROR';

export const SEND_ENQUIRY_REQUEST = 'app/ListingPage/SEND_ENQUIRY_REQUEST';
export const SEND_ENQUIRY_SUCCESS = 'app/ListingPage/SEND_ENQUIRY_SUCCESS';
export const SEND_ENQUIRY_ERROR = 'app/ListingPage/SEND_ENQUIRY_ERROR';


// New

export const SEND_CALENDAR_LINK_REQUEST = 'app/TransactionPage/SEND_CALENDAR_LINK_REQUEST';
export const SEND_CALENDAR_LINK_SUCCESS = 'app/TransactionPage/SEND_CALENDAR_LINK_SUCCESS';
export const SEND_CALENDAR_LINK_ERROR = 'app/TransactionPage/SEND_CALENDAR_LINK_ERROR';

export const SEND_OFFER_REQUEST = 'app/TransactionPage/SEND_OFFER_REQUEST';
export const SEND_OFFER_SUCCESS = 'app/TransactionPage/SEND_OFFER_SUCCESS';
export const SEND_OFFER_ERROR = 'app/TransactionPage/SEND_OFFER_ERROR';

export const APPROVE_OFFER_REQUEST = 'app/TransactionPage/APPROVE_OFFER_REQUEST';
export const APPROVE_OFFER_SUCCESS = 'app/TransactionPage/APPROVE_OFFER_SUCCESS';
export const APPROVE_OFFER_ERROR = 'app/TransactionPage/APPROVE_OFFER_ERROR';

export const MAKE_TRANSITION_REQUEST = 'app/TransactionPage/MAKE_TRANSITION_REQUEST';
export const MAKE_TRANSITION_SUCCESS = 'app/TransactionPage/MAKE_TRANSITION_SUCCESS';
export const MAKE_TRANSITION_ERROR = 'app/TransactionPage/MAKE_TRANSITION_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchTransactionInProgress: false,
  fetchTransactionError: null,
  transactionRef: null,
  acceptInProgress: false,
  acceptSaleError: null,
  declineInProgress: false,
  declineSaleError: null,
  fetchMessagesInProgress: false,
  fetchMessagesError: null,
  totalMessages: 0,
  totalMessagePages: 0,
  oldestMessagePageFetched: 0,
  messages: [],
  initialMessageFailedToTransaction: null,
  savePaymentMethodFailed: false,
  sendMessageInProgress: false,
  sendMessageError: null,
  sendReviewInProgress: false,
  sendReviewError: null,
  monthlyTimeSlots: {
    // '2019-12': {
    //   timeSlots: [],
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  fetchTransitionsInProgress: false,
  fetchTransitionsError: null,
  processTransitions: null,
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  enquiryActionInProgress: false,
  enquiryActionError: null,

  sendEnquiryInProgress: false,
  sendEnquiryError: null,

  approveOfferInProgress: false,
  approveOfferError: null,

  sendCalendarLinkInProgress: false,
  sendCalendarLinkError: null,
  calendarLink: null,
  transitionInProgress: false,
  transitionError: null,
};

// Merge entity arrays using ids, so that conflicting items in newer array (b) overwrite old values (a).
// const a = [{ id: { uuid: 1 } }, { id: { uuid: 3 } }];
// const b = [{ id: : { uuid: 2 } }, { id: : { uuid: 1 } }];
// mergeEntityArrays(a, b)
// => [{ id: { uuid: 3 } }, { id: : { uuid: 2 } }, { id: : { uuid: 1 } }]
const mergeEntityArrays = (a, b) => {
  return a.filter(aEntity => !b.find(bEntity => aEntity.id.uuid === bEntity.id.uuid)).concat(b);
};

export default function checkoutPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case FETCH_TRANSACTION_REQUEST:
      return { ...state, fetchTransactionInProgress: true, fetchTransactionError: null };
    case FETCH_TRANSACTION_SUCCESS: {
      const transactionRef = { id: payload.data.data.id, type: 'transaction' };
      return { ...state, fetchTransactionInProgress: false, transactionRef };
    }
    case FETCH_TRANSACTION_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransactionInProgress: false, fetchTransactionError: payload };

    case FETCH_TRANSITIONS_REQUEST:
      return { ...state, fetchTransitionsInProgress: true, fetchTransitionsError: null };
    case FETCH_TRANSITIONS_SUCCESS:
      return { ...state, fetchTransitionsInProgress: false, processTransitions: payload };
    case FETCH_TRANSITIONS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransitionsInProgress: false, fetchTransitionsError: payload };

    case FETCH_MESSAGES_REQUEST:
      return { ...state, fetchMessagesInProgress: true, fetchMessagesError: null };
    case FETCH_MESSAGES_SUCCESS: {
      const oldestMessagePageFetched =
        state.oldestMessagePageFetched > payload.page
          ? state.oldestMessagePageFetched
          : payload.page;
      return {
        ...state,
        fetchMessagesInProgress: false,
        messages: mergeEntityArrays(state.messages, payload.messages),
        totalMessages: payload.totalItems,
        totalMessagePages: payload.totalPages,
        oldestMessagePageFetched,
      };
    }
    case FETCH_MESSAGES_ERROR:
      return { ...state, fetchMessagesInProgress: false, fetchMessagesError: payload };

    case SEND_MESSAGE_REQUEST:
      return {
        ...state,
        sendMessageInProgress: true,
        sendMessageError: null,
        initialMessageFailedToTransaction: null,
      };
    case SEND_MESSAGE_SUCCESS:
      return { ...state, sendMessageInProgress: false };
    case SEND_MESSAGE_ERROR:
      return { ...state, sendMessageInProgress: false, sendMessageError: payload };

    case SEND_REVIEW_REQUEST:
      return { ...state, sendReviewInProgress: true, sendReviewError: null };
    case SEND_REVIEW_SUCCESS:
      return { ...state, sendReviewInProgress: false };
    case SEND_REVIEW_ERROR:
      return { ...state, sendReviewInProgress: false, sendReviewError: payload };

    case FETCH_TIME_SLOTS_REQUEST: {
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [payload]: {
          ...state.monthlyTimeSlots[payload],
          fetchTimeSlotsError: null,
          fetchTimeSlotsInProgress: true,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_SUCCESS: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          timeSlots: payload.timeSlots,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_ERROR: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          fetchTimeSlotsError: payload.error,
        },
      };
      return { ...state, monthlyTimeSlots };
    }

    case FETCH_LINE_ITEMS_REQUEST:
      return { ...state, fetchLineItemsInProgress: true, fetchLineItemsError: null };
    case FETCH_LINE_ITEMS_SUCCESS:
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case FETCH_LINE_ITEMS_ERROR:
      return { ...state, fetchLineItemsInProgress: false, fetchLineItemsError: payload };

    case ENQUIRY_ACTION_REQUEST:
      return { ...state, enquiryActionInProgress: true, enquiryActionError: null };
    case ENQUIRY_ACTION_SUCCESS:
      return { ...state, enquiryActionInProgress: false };
    case ENQUIRY_ACTION_ERROR:
      return { ...state, enquiryActionInProgress: false, enquiryActionError: payload };

    case SEND_ENQUIRY_REQUEST:
      return { ...state, sendEnquiryInProgress: true, sendEnquiryError: null };
    case SEND_ENQUIRY_SUCCESS:
      return { ...state, sendEnquiryInProgress: false };
    case SEND_ENQUIRY_ERROR:
      return { ...state, sendEnquiryInProgress: false, sendEnquiryError: payload };


    case SEND_CALENDAR_LINK_REQUEST:
      return { ...state, sendCalendarLinkInProgress: true, sendCalendarLinkError: null };
    case SEND_CALENDAR_LINK_SUCCESS:
      return { ...state, sendCalendarLinkInProgress: false, calendarLink: payload };
    case SEND_CALENDAR_LINK_ERROR:
      return { ...state, sendCalendarLinkInProgress: false, sendCalendarLinkError: payload };


    case SEND_OFFER_REQUEST:
      return { ...state, sendOfferInProgress: true, sendOfferError: null };
    case SEND_OFFER_SUCCESS:
      return { ...state, sendOfferInProgress: false };
    case SEND_OFFER_ERROR:
      return { ...state, sendOfferInProgress: false, sendOfferError: payload };


    case APPROVE_OFFER_REQUEST:
      return { ...state, approveOfferInProgress: true, approveOfferError: null };
    case APPROVE_OFFER_SUCCESS:
      return { ...state, approveOfferInProgress: false };
    case APPROVE_OFFER_ERROR:
      return { ...state, approveOfferInProgress: false, approveOfferError: payload };

    case MAKE_TRANSITION_REQUEST:
      return { ...state, transitionInProgress: true, transitionError: null };
    case MAKE_TRANSITION_SUCCESS:
      return { ...state, transitionInProgress: false };
    case MAKE_TRANSITION_ERROR:
      return { ...state, transitionInProgress: false, transitionError: payload };

    default:
      return state;
  }
}

// ================ Selectors ================ //

export const acceptOrDeclineInProgress = state => {
  return state.TransactionPage.acceptInProgress || state.TransactionPage.declineInProgress;
};

// ================ Action creators ================ //
export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

const fetchTransactionRequest = () => ({ type: FETCH_TRANSACTION_REQUEST });
const fetchTransactionSuccess = response => ({
  type: FETCH_TRANSACTION_SUCCESS,
  payload: response,
});
const fetchTransactionError = e => ({ type: FETCH_TRANSACTION_ERROR, error: true, payload: e });

const fetchTransitionsRequest = () => ({ type: FETCH_TRANSITIONS_REQUEST });
const fetchTransitionsSuccess = response => ({
  type: FETCH_TRANSITIONS_SUCCESS,
  payload: response,
});
const fetchTransitionsError = e => ({ type: FETCH_TRANSITIONS_ERROR, error: true, payload: e });


const fetchMessagesRequest = () => ({ type: FETCH_MESSAGES_REQUEST });
const fetchMessagesSuccess = (messages, pagination) => ({
  type: FETCH_MESSAGES_SUCCESS,
  payload: { messages, ...pagination },
});
const fetchMessagesError = e => ({ type: FETCH_MESSAGES_ERROR, error: true, payload: e });

const sendMessageRequest = () => ({ type: SEND_MESSAGE_REQUEST });
const sendMessageSuccess = () => ({ type: SEND_MESSAGE_SUCCESS });
const sendMessageError = e => ({ type: SEND_MESSAGE_ERROR, error: true, payload: e });

const sendReviewRequest = () => ({ type: SEND_REVIEW_REQUEST });
const sendReviewSuccess = () => ({ type: SEND_REVIEW_SUCCESS });
const sendReviewError = e => ({ type: SEND_REVIEW_ERROR, error: true, payload: e });

export const fetchTimeSlotsRequest = monthId => ({
  type: FETCH_TIME_SLOTS_REQUEST,
  payload: monthId,
});
export const fetchTimeSlotsSuccess = (monthId, timeSlots) => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: { timeSlots, monthId },
});
export const fetchTimeSlotsError = (monthId, error) => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: { monthId, error },
});

export const fetchLineItemsRequest = () => ({ type: FETCH_LINE_ITEMS_REQUEST });
export const fetchLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});
export const fetchLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  error: true,
  payload: error,
});

const enquiryActionRequest = () => ({ type: ENQUIRY_ACTION_REQUEST });
const enquiryActionSuccess = () => ({ type: ENQUIRY_ACTION_SUCCESS });
const enquiryActionError = e => ({ type: ENQUIRY_ACTION_ERROR, error: true, payload: e });

export const sendEnquiryRequest = () => ({ type: SEND_ENQUIRY_REQUEST });
export const sendEnquirySuccess = () => ({ type: SEND_ENQUIRY_SUCCESS });
export const sendEnquiryError = e => ({ type: SEND_ENQUIRY_ERROR, error: true, payload: e });

const sendCalendarLinkRequest = () => ({ type: SEND_CALENDAR_LINK_REQUEST });
const sendCalendarLinkSuccess = (payload) => ({ type: SEND_CALENDAR_LINK_SUCCESS, payload });
const sendCalendarLinkError = e => ({ type: SEND_CALENDAR_LINK_ERROR, error: true, payload: e });


const sendOfferRequest = () => ({ type: SEND_OFFER_REQUEST });
const sendOfferSuccess = () => ({ type: SEND_OFFER_SUCCESS });
const sendOfferError = e => ({ type: SEND_OFFER_ERROR, error: true, payload: e });

const approveOfferRequest = () => ({ type: APPROVE_OFFER_REQUEST });
const approveOfferSuccess = () => ({ type: APPROVE_OFFER_SUCCESS });
const approveOfferError = e => ({ type: APPROVE_OFFER_ERROR, error: true, payload: e });

const transitionRequest = () => ({ type: MAKE_TRANSITION_REQUEST });
const transitionSuccess = () => ({ type: MAKE_TRANSITION_SUCCESS });
const transitionError = e => ({ type: MAKE_TRANSITION_ERROR, error: true, payload: e });

// ================ Thunks ================ //

const timeSlotsRequest = params => (dispatch, getState, sdk) => {
  return sdk.timeslots.query(params).then(response => {
    return denormalisedResponseEntities(response);
  });
};

export const fetchTimeSlots = (listingId, start, end, timeZone) => (dispatch, getState, sdk) => {
  const monthId = monthIdStringInTimeZone(start, timeZone);

  dispatch(fetchTimeSlotsRequest(monthId));

  // The maximum pagination page size for timeSlots is 500
  const extraParams = {
    per_page: 500,
    page: 1,
  };

  return dispatch(timeSlotsRequest({ listingId, start, end, ...extraParams }))
    .then(timeSlots => {
      dispatch(fetchTimeSlotsSuccess(monthId, timeSlots));
    })
    .catch(e => {
      dispatch(fetchTimeSlotsError(monthId, storableError(e)));
    });
};

// Helper function for fetchTransaction call.
const fetchMonthlyTimeSlots = (dispatch, listing) => {
  const hasWindow = typeof window !== 'undefined';
  const attributes = listing.attributes;
  // Listing could be ownListing entity too, so we just check if attributes key exists
  const hasTimeZone =
    attributes && attributes.availabilityPlan && attributes.availabilityPlan.timezone;

  // Fetch time-zones on client side only.
  if (hasWindow && listing.id && hasTimeZone) {
    const tz = listing.attributes.availabilityPlan.timezone;
    const nextBoundary = findNextBoundary(tz, new Date());

    const nextMonth = nextMonthFn(nextBoundary, tz);
    const nextAfterNextMonth = nextMonthFn(nextMonth, tz);

    return Promise.all([
      dispatch(fetchTimeSlots(listing.id, nextBoundary, nextMonth, tz)),
      dispatch(fetchTimeSlots(listing.id, nextMonth, nextAfterNextMonth, tz)),
    ]);
  }

  // By default return an empty array
  return Promise.all([]);
};

const listingRelationship = txResponse => {
  return txResponse.data.data.relationships.listing.data;
};

export const fetchTransaction = (id, txRole) => (dispatch, getState, sdk) => {
  dispatch(fetchTransactionRequest());
  let txResponse = null;

  let currentUserId;

  return sdk.currentUser.show()
    .then(response => {

      currentUserId = response?.data?.data?.id?.uuid;

      return sdk.transactions.show(
        {
          id,
          include: [
            'customer',
            'customer.profileImage',
            'provider',
            'provider.profileImage',
            'listing',
            'booking',
            'reviews',
            'reviews.author',
            'reviews.subject',
          ],
          ...IMAGE_VARIANTS,
        },
        { expand: true }
      )
    })
    .then(response => {
      const metaData = response?.data?.data?.attributes?.metadata;
      const hasUnreadMessages = !!metaData?.unreadMessages?.[currentUserId] || !metaData?.viewed?.[currentUserId];

      if (hasUnreadMessages) {
        removeCustomerEmailReminder(currentUserId, 'newMessageReminder', id.uuid,)
      }
      return response;
    })
    .then(response => {
      txResponse = response;
      const listingId = listingRelationship(response).id;
      const entities = updatedEntities({}, response.data);
      const listingRef = { id: listingId, type: 'listing' };
      const transactionRef = { id, type: 'transaction' };
      const denormalised = denormalisedEntities(entities, [listingRef, transactionRef]);
      const listing = denormalised[0];
      const transaction = denormalised[1];

      // Fetch time slots for transactions that are in enquired state
      const canFetchTimeslots =
        txRole === 'customer' &&
        config.enableAvailability &&
        transaction &&
        txIsEnquired(transaction) && txIsRequestedContact(transaction);

      if (canFetchTimeslots) {
        fetchMonthlyTimeSlots(dispatch, listing);
      }

      const canFetchListing = listing && listing.attributes && !listing.attributes.deleted;
      if (canFetchListing) {
        return sdk.listings.show({
          id: listingId,
          include: ['author', 'author.profileImage', 'images'],
          ...IMAGE_VARIANTS,
        });
      } else {
        return response;
      }
    })
    .then(response => {
      dispatch(addMarketplaceEntities(txResponse));
      dispatch(addMarketplaceEntities(response));
      dispatch(fetchTransactionSuccess(txResponse));
      return response;
    })
    .catch(e => {
      dispatch(fetchTransactionError(storableError(e)));
      throw e;
    });
};

export const sendOffer = (values, transaction, transition) => (dispatch, getState, sdk) => {
  dispatch(sendOfferRequest());

  const id = transaction.id;
  const { currentUser } = getState().user;
  const otherUserId = getOtherUserId(currentUser, transaction);

  const newOffer = { price: +values?.price, currency: values?.currency, message: values?.message };
  const oldOffers = transaction?.attributes?.protectedData?.offersData || [];
  const offersData = [newOffer, ...oldOffers];

  let offerCounter = transaction?.attributes?.protectedData?.offerCounter || 0;

  return sdk.transactions
    .transition({
      id,
      transition,
      params: {
        protectedData: { offersData, offerCounter: ++offerCounter },
      },
    }, { expand: true })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(sendOfferSuccess());
      return response;
    })
    .then(response => {
      return setViewedForOtherUser(currentUser, transaction, otherUserId);
    })
    .then(response => {
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .catch(e => {
      dispatch(sendOfferError(storableError(e)));
      log.error(e, 'send-offer-failed', {
        txId: id,
        transition,
      });
      throw e;
    });
};

export const approveOffer = (transaction, transition) => (dispatch, getState, sdk) => {
  dispatch(approveOfferRequest());

  const id = transaction.id;
  const { currentUser } = getState().user;
  const otherUserId = getOtherUserId(currentUser, transaction);

  return sdk.transactions
    .transition({
      id,
      transition,
      params: {},
    }, { expand: true })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(approveOfferSuccess());
      return response;
    })
    .then(response => {
      return setViewedForOtherUser(currentUser, transaction, otherUserId);
    })
    .then(response => {
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .catch(e => {
      dispatch(approveOfferError(storableError(e)));
      log.error(e, 'approve-offer-failed', {
        txId: id,
        transition
      });
      throw e;
    });
};

export const cancellOffer = (transaction, transition) => (dispatch, getState, sdk) => {

  const id = transaction.id;
  const { currentUser } = getState().user;

  const otherUserId = getOtherUserId(currentUser, transaction);

  return sdk.transactions
    .transition({
      id,
      transition,
      params: {},
    }, { expand: true })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      return response;
    })
    .then(response => {
      return setViewedForOtherUser(currentUser, transaction, otherUserId);
    })
    .then(response => {
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .catch(e => {
      log.error(e, 'cancell-offer-failed', {
        txId: id,
        transition,
      });
      throw e;
    });
};

export const completeOfferRequest = (transaction, transition, values) => (dispatch, getState, sdk) => {

  const id = transaction.id;
  const customerId = transaction.customer.id.uuid;
  const providerCompanyName = transaction.listing.attributes.title;

  let completeOfferRequestCounter = transaction?.attributes?.protectedData?.completeOfferRequestCounter || 0;
  let currentDesclineDescription = transaction?.attributes?.protectedData?.desclineDescription || [];

  const { currentUser } = getState().user;
  const otherUserId = getOtherUserId(currentUser, transaction);
  const otherUserRole = transaction.customer.id.uuid === currentUser.id.uuid ? "sale" : "order";

  const nextTransitionIndex = transaction?.attributes?.transitions?.length + 1

  return sdk.transactions
    .transition({
      id,
      transition,
      params: {
        protectedData: {
          completeOfferRequestCounter: ++completeOfferRequestCounter,
          desclineDescription: transition === TRANSITION_DECLINE_OFFER_COMPLETE ?
            [...currentDesclineDescription, { key: nextTransitionIndex, value: values?.declineOfferDescription }]
            : currentDesclineDescription
        },
      },
    }, { expand: true })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      return response;
    })
    .then(response => {
      if (transition === TRANSITION_REQUEST_OFFER_COMPLETE) {
        return addCustomerEmailReminder({ userId: customerId, transactionId: id.uuid, listingTitle: providerCompanyName, template: 'workSubmittedReminder' })
      }
      else if (
        transition === TRANSITION_ACCEPT_OFFER_COMPLETE ||
        transition === TRANSITION_DECLINE_OFFER_COMPLETE
      ) {
        return removeCustomerEmailReminder(customerId, 'workSubmittedReminder', id.uuid,)
      }
      else {
        return response;
      }
    })
    .then(() => {
      return setViewedForOtherUser(currentUser, transaction, otherUserId);
    })
    .then(response => {
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .catch(e => {
      log.error(e, `${transition} failed`, {
        txId: id,
        transition,
      });
      throw e;
    });
};

const fetchMessages = (txId, page) => (dispatch, getState, sdk) => {
  const paging = { page, per_page: MESSAGES_PAGE_SIZE };
  dispatch(fetchMessagesRequest());

  return sdk.messages
    .query({
      transaction_id: txId,
      include: ['sender', 'sender.profileImage'],
      ...IMAGE_VARIANTS,
      ...paging,
    })
    .then(response => {
      const messages = denormalisedResponseEntities(response);
      const { totalItems, totalPages, page: fetchedPage } = response.data.meta;
      const pagination = { totalItems, totalPages, page: fetchedPage };
      const totalMessages = getState().TransactionPage.totalMessages;

      // Original fetchMessages call succeeded
      dispatch(fetchMessagesSuccess(messages, pagination));

      // Check if totalItems has changed between fetched pagination pages
      // if totalItems has changed, fetch first page again to include new incoming messages.
      // TODO if there're more than 100 incoming messages,
      // this should loop through most recent pages instead of fetching just the first one.
      if (totalItems > totalMessages && page > 1) {
        dispatch(fetchMessages(txId, 1))
          .then(() => {
            // Original fetch was enough as a response for user action,
            // this just includes new incoming messages
          })
          .catch(() => {
            // Background update, no need to to do anything atm.
          });
      }
    })
    .catch(e => {
      dispatch(fetchMessagesError(storableError(e)));
      throw e;
    });
};

export const fetchMoreMessages = txId => (dispatch, getState, sdk) => {
  const state = getState();
  const { oldestMessagePageFetched, totalMessagePages } = state.TransactionPage;
  const hasMoreOldMessages = totalMessagePages > oldestMessagePageFetched;

  // In case there're no more old pages left we default to fetching the current cursor position
  const nextPage = hasMoreOldMessages ? oldestMessagePageFetched + 1 : oldestMessagePageFetched;

  return dispatch(fetchMessages(txId, nextPage));
};

export const sendMessage = (transaction, otherUserId, message, notificationParams) => (dispatch, getState, sdk) => {
  dispatch(sendMessageRequest());

  const txId = transaction.id.uuid;

  const { currentUser } = getState().user;
  const otherUserRole = transaction.customer.id.uuid === currentUser.id.uuid ? 'sale' : 'order';

  return sdk.messages
    .send({ transactionId: txId, content: message })
    .then(response => {
      const messageId = response.data.data.id;
      // We fetch the first page again to add sent message to the page data
      // and update possible incoming messages too.
      // TODO if there're more than 100 incoming messages,
      // this should loop through most recent pages instead of fetching just the first one.
      return dispatch(fetchMessages(txId, 1))
        .then(() => {
          dispatch(sendMessageSuccess());
          return messageId;
        })
        .catch(() => dispatch(sendMessageSuccess()));
    })
    .then(response => {

      addCustomerEmailReminder({
        userId: otherUserId,
        transactionId: txId,
        template: 'newMessageReminder',
        saleOrOrder: otherUserRole,
      })
      return response
    })
    .catch(e => {
      console.log(e);
      dispatch(sendMessageError(storableError(e)));
      // Rethrow so the page can track whether the sending failed, and
      // keep the message in the form for a retry.
      throw e;
    });
};


export const sendCalendarLink = (transaction, calendarLink) => (dispatch, getState, sdk) => {
  dispatch(sendCalendarLinkRequest());
  // const id = transaction.id;
  // const { currentUser } = getState().user;

  const txId = transaction.id.uuid;

  const { currentUser } = getState().user;
  const otherUserRole = transaction.customer.id.uuid === currentUser.id.uuid ? 'sale' : 'order';
  const otherUserId = getOtherUserId(currentUser, transaction);

  return sdk.messages
    // .send({ transactionId: txId, content: `View the calendar link: ${calendarLink}` })
    .send({ transactionId: txId, content: `Check the calendar link` })
    .then(response => {
      const messageId = response.data.data.id;
      // We fetch the first page again to add sent message to the page data
      // and update possible incoming messages too.
      // TODO if there're more than 100 incoming messages,
      // this should loop through most recent pages instead of fetching just the first one.

      return dispatch(fetchMessages(txId, 1))
        .then(() => {
          dispatch(sendMessageSuccess());
          dispatch(sendCalendarLinkSuccess());
          return messageId;
        })
        .catch(() => dispatch(sendMessageSuccess()));
    })
    .then(response => {

      updateTransaction({
        id: txId,
        metadata: { calendarLink }
      }).then(response => {

        dispatch(fetchTransaction(transaction.id, 'provider'))
        dispatch(fetchMessages(transaction.id, 1))
        dispatch(fetchNextTransitions(transaction.id))

        return response
      }).catch(e => console.log(e));
      return response
    })
    .then(response => {
      addCustomerEmailReminder({
        userId: otherUserId,
        transactionId: txId,
        template: 'newMessageReminder',
        saleOrOrder: otherUserRole,
      })
      return response
    })
    .catch(e => {
      dispatch(sendCalendarLinkError(storableError(e)));
      throw e;
    });


  // return sdk.transactions
  //   .transition(
  //     {
  //       id,
  //       transition: TRANSITION_SEND_CALENDAR_LINK,
  //       params: {
  //         protectedData: {
  //           calendarLink,
  //         },
  //       },
  //     },
  //     { expand: true }
  //   )
  //   .then(response => {
  //     dispatch(addMarketplaceEntities(response));
  //     dispatch(sendCalendarLinkSuccess());
  //     return response;
  //   })
  //   .then(response => {
  //     return setViewedForOtherUser(currentUser, transaction, otherUserId);
  //   })
  //   .then(response => {
  //     dispatch(fetchCurrentUserNotifications());
  //     return response;
  //   })
  //   .catch(e => {
  //     dispatch(sendCalendarLinkError(storableError(e)));
  //     log.error(e, 'send-calendar-failed', {
  //       txId: id,
  //       transition: TRANSITION_SEND_CALENDAR_LINK,
  //     });
  //     throw e;
  //   });
};

export const uploadFile = (values, transaction, role) => (dispatch, getState, sdk) => {

  const id = transaction.id;
  const { currentUser } = getState().user;
  const otherUserId = getOtherUserId(currentUser, transaction);
  const otherUserRole = transaction.customer.id.uuid === currentUser.id.uuid ? 'sale' : 'order';

  const savedInvoice = transaction?.attributes?.metadata?.invoice;
  const savedContract = transaction?.attributes?.metadata?.contract;
  const savedSignedContract = transaction?.attributes?.metadata?.signedContract;

  const validInvoice = values?.invoice.filter(file => !!file);
  const validContract = values?.contract.filter(file => !!file);
  const validSignedContract = values?.signedContract.filter(file => !!file);

  let messagesText = '';

  if (role === 'provider' && !!validInvoice?.[0] && !!validContract?.[0]) {
    messagesText = 'Invoice and contract are uploaded'
  }
  else if (role === 'provider' && !!validInvoice?.[0]) {
    messagesText = 'Invoice is uploaded'
  }
  else if (role === 'provider' && !!validContract?.[0]) {
    messagesText = 'Contract is uploaded'
  }
  else if (role === 'customer' && !!validSignedContract?.[0]) {
    messagesText = 'Signed contract is uploaded'
  }

  return sdk.messages
    // .send({ transactionId: txId, content: `View the calendar link: ${calendarLink}` })
    .send({ transactionId: id.uuid, content: messagesText })
    .then(response => {
      const messageId = response.data.data.id;
      // We fetch the first page again to add sent message to the page data
      // and update possible incoming messages too.
      // TODO if there're more than 100 incoming messages,
      // this should loop through most recent pages instead of fetching just the first one.

      return dispatch(fetchMessages(id.uuid, 1))
        .then(() => {
          dispatch(sendMessageSuccess());
          dispatch(sendCalendarLinkSuccess());
          return messageId;
        })
        .catch(() => dispatch(sendMessageSuccess()));
    })
    .then(response => {
      updateTransaction({
        id: id.uuid,
        metadata: {
          invoice: !!validInvoice?.[0] ? validInvoice : savedInvoice,
          contract: !!validContract?.[0] ? validContract : savedContract,
          signedContract: !!validSignedContract?.[0] ? validSignedContract : savedSignedContract,
        },
      }).then(response => {

        dispatch(fetchTransaction(transaction.id, role))
        dispatch(fetchMessages(transaction.id, 1))
        dispatch(fetchNextTransitions(transaction.id))

        return response
      }).catch(e => console.log(e));

      return response
    })
    .then(response => {
      addCustomerEmailReminder({
        userId: otherUserId,
        transactionId: id.uuid,
        template: 'newMessageReminder',
        saleOrOrder: otherUserRole,
      })
      return response
    })
    .catch(e => {
      console.log(e);
      throw e;
    });


  // return sdk.transactions
  //   .transition({
  //     id,
  //     transition,
  //     params: {
  //       metadata: {
  //         invoice: !!validInvoice?.[0] ? validInvoice : savedInvoice,
  //         contract: !!validContract?.[0] ? validContract : savedContract,
  //         signedContract: !!validSignedContract?.[0] ? validSignedContract : savedSignedContract,
  //       },
  //     },
  //   }, { expand: true })
  //   .then(response => {
  //     dispatch(addMarketplaceEntities(response));
  //     return response;
  //   })
  //   .then(response => {
  //     return setViewedForOtherUser(currentUser, transaction, otherUserId);
  //   })
  //   .then(response => {
  //     dispatch(fetchCurrentUserNotifications());
  //     return response;
  //   })
  //   .catch(e => {
  //     log.error(e, `${transition} failed`, {
  //       txId: id,
  //       transition,
  //     });
  //     throw e;
  //   });
};

const REVIEW_TX_INCLUDES = ['reviews', 'reviews.author', 'reviews.subject'];
const IMAGE_VARIANTS = {
  'fields.image': [
    // Profile images
    'variants.square-small',
    'variants.square-small2x',

    // Listing images:
    'variants.landscape-crop',
    'variants.landscape-crop2x',
  ],
};


const isNonEmpty = value => {
  return typeof value === 'object' || Array.isArray(value) ? !isEmpty(value) : !!value;
};

export const fetchNextTransitions = id => (dispatch, getState, sdk) => {
  dispatch(fetchTransitionsRequest());

  return sdk.processTransitions
    .query({ transactionId: id })
    .then(res => {
      dispatch(fetchTransitionsSuccess(res.data.data));
    })
    .catch(e => {
      dispatch(fetchTransitionsError(storableError(e)));
    });
};

export const fetchTransactionLineItems = ({ bookingData, listingId, isOwnListing }) => dispatch => {
  dispatch(fetchLineItemsRequest());
  transactionLineItems({ bookingData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        bookingData: bookingData,
      });
    });
};


export const sendEnquiry = (transaction, enquiryValues) => (dispatch, getState, sdk) => {
  dispatch(sendEnquiryRequest());

  const id = transaction.id;
  const { currentUser } = getState().user;
  const otherUserId = getOtherUserId(currentUser, transaction);

  const questions = { ...enquiryValues };
  //remove message from enquiryValues
  if (questions?.message) {
    delete questions?.message;
  }

  const bodyParams = {
    transition: TRANSITION_REQUEST_AFTER_ENQUIRY,
    id,
    params: {
      protectedData: {
        questions
      },
    },
  };

  const message = enquiryValues?.message?.trim();
  return sdk.transactions
    .transition(bodyParams)
    .then(response => {
      const transactionId = response.data.data.id;

      // Send the message to the created transaction
      return sdk.messages.send({ transactionId, content: message }).then(() => {
        dispatch(sendEnquirySuccess());

        dispatch(fetchTransaction(transactionId, "customer"));
        dispatch(fetchMessages(transactionId, 1));
        dispatch(fetchNextTransitions(transactionId));

        return transactionId;
      });
    })
    .then(response => {
      const currentUserId = currentUser?.id?.uuid;
      const customer = transaction.customer;
      const provider = transaction.provider;
      const otherUser = [provider, customer].find(u => u?.id?.uuid !== currentUserId);
      const userId = otherUser.id.uuid;

      setUnreadMessagesToTx({ txId: id.uuid, userId: userId });

      return response
    })
    .then(response => {
      return setViewedForOtherUser(currentUser, transaction, otherUserId);
    })
    .then(response => {
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .catch(e => {
      dispatch(sendEnquiryError(storableError(e)));
      throw e;
    });
};

export const makeTransition = (params) => (dispatch, getState, sdk) => {
  const { transactionId, transition, role } = params;
  dispatch(transitionRequest());

  const bodyParams = {
    transition,
    id: transactionId,
    params: {},
  };

  return sdk.transactions
    .transition(bodyParams)
    .then(response => {
      dispatch(transitionSuccess());
      dispatch(fetchTransaction(transactionId, role));
      dispatch(fetchNextTransitions(transactionId));

      return response;
    })
    .then(response => {
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .catch(e => {
      dispatch(transitionError("Action Failed, please refresh the page and try again."));
      throw e;
    });
};

// loadData is a collection of async calls that need to be made
// before page has all the info it needs to render itself
export const loadData = params => (dispatch, getState) => {
  const txId = new UUID(params.id);
  const state = getState().TransactionPage;
  const txRef = state.transactionRef;
  const txRole = params.transactionRole;

  // In case a transaction reference is found from a previous
  // data load -> clear the state. Otherwise keep the non-null
  // and non-empty values which may have been set from a previous page.
  const initialValues = txRef ? {} : pickBy(state, isNonEmpty);
  dispatch(setInitialValues(initialValues));

  // Sale / order (i.e. transaction entity in API)
  return Promise.all([
    dispatch(fetchTransaction(txId, txRole)),
    dispatch(fetchMessages(txId, 1)),
    dispatch(fetchNextTransitions(txId)),
  ]);
};
